import { CertificationGate } from '@/components/sidebar/CertificationGate';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { P } from '@/app/guards';
import {
  ArchivesFiscales,
  Certificat,
  ClotureComptable,
  CodesPostaux,
  ConfigFeatureFlags,
  ConfigAppareils,
  ConfigKioskMode,
  ConfigTPE,
  ConfigUniverses,
  FidelitePunch,
  HardwareConfig,
  Identites,
  ImportDonnees,
  Lekompte,
  ParametresDossier,
  Pays,
  PeriodesAnnee,
  PeriodesComptable,
  PeriodesJour,
  PeriodesMois,
  PistesAudit,
  PostesTravail,
  ProfilsFidelite,
  TpeBluetoothManager,
  ZonesLivraison,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function configSystemRoutes() {
  return (
    <>
      <Route
        path="/config/tpe"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ConfigTPE />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/tpe-bluetooth"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TpeBluetoothManager />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/pistes-audit"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <PistesAudit />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/archives-fiscales"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <ArchivesFiscales />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/finance/cloture-comptable"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ClotureComptable />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/finance/lekompte"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Lekompte />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/periodes-jour"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <PeriodesJour />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/periodes-mois"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <PeriodesMois />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/periodes-annee"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <PeriodesAnnee />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/periodes-comptable"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <PeriodesComptable />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/certificat"
        element={
          <P>
            <ErrorBoundary>
              <CertificationGate>
                <Suspense fallback={<LoadingSpinner />}>
                  <Certificat />
                </Suspense>
              </CertificationGate>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/:type"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <HardwareConfig />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/profils-fidelite"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ProfilsFidelite />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/fidelite-punch"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FidelitePunch />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/identites"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Identites />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/codes-postaux"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <CodesPostaux />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/pays"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Pays />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/zones-livraison"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ZonesLivraison />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/postes-travail"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <PostesTravail />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/import"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ImportDonnees />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/parametres-dossier"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ParametresDossier />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/feature-flags"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ConfigFeatureFlags />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/appareils"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ConfigAppareils />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/kiosk"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ConfigKioskMode />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/univers"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ConfigUniverses />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
    </>
  );
}
